import React, { Component } from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import axios from 'axios';
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone
} from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import '../../Asset/Css/util.css';
import '../../Asset/Css/main.css';
import { Link } from 'react-router-dom';
import global from '../global';
import moment from 'moment';
import Popup from './Part2DocUploader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { config } from '../../Constants';
import download from 'downloadjs';
import { Layout } from '../Layout';
import Spinner from '../Spinner';
import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'
import { store } from 'react-notifications-component';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { faHome, faCoffee, faPencilAlt, faCloudDownloadAlt, faIdCard, faKey, faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons'
const { SearchBar } = Search;

library.add(fab, faHome, faCoffee, faPencilAlt, faCloudDownloadAlt, faIdCard, faKey, faCloudUploadAlt)



export class FetchPart2Details extends Component {
    displayName = 'Part2'

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            assignmentCode: '',
            RemitterCode: '',
            URL: config.url.API_URL,
            part2: [],
            columns: [{
                dataField: 'ID',
                text: 'Assignment Code',
                hidden: true
            },
            {
                dataField: 'AssignmentName',
                text: 'Assignment',
                headerAlign: 'center'

            },
            {
                dataField: 'RemitterName',
                text: 'Remitter',
                headerAlign: 'center',
                sort: true,

            },
            {
                dataField: 'FinancialYear',
                text: 'Financial Year',
                headerAlign: 'center',
                align: 'center',
                sort: true,
                },
                {
                    dataField: 'DeclarationCount',
                    text: 'Declaration Count',
                    headerAlign: 'center',
                    align: 'center',
                    sort: true,
                },
               
            {
                dataField: "Download",
                text: "Download",
                headerAlign: 'center',
                align: 'center',
                formatter: (rowContent, row) => {
                    return (
                        <div>
                            <button className="btn btn-primary p-10 m-l-10"
                                title="Download Part 2 Details Template"
                                onClick={e => {
                                    e.persist();
                                    FetchPart2Details.handleDownload(row.ID)
                                }}> <FontAwesomeIcon icon="cloud-download-alt" /> </button> 
                        </div>
                    )
                }
                },
                {
                    dataField: "Upload",
                    text: "Upload",
                    headerAlign: 'center',
                    align: 'center',
                    formatter: (rowContent, row) => {
                        return (
                            <div>
                                <button className="btn btn-success p-10 m-l-10" title="Upload Part 2 Details"
                                    onClick={e => {
                                        e.persist();
                                        this.setState({ modal: true, file: '', assignmentCode: row.ID });

                                    }}> <FontAwesomeIcon icon="cloud-upload-alt" /> </button> 
                            </div>
                        )
                    }
                },
            ],
            loading: false,
        }
        this.initialstate = this.state;
        this.modalClose = this.modalClose.bind(this);

    }

    componentDidMount() {

        //axios.get(global.UserManagement.GetSessionDetailsAPI)
        //    .then(response => {
        //        if (response.data.Status) {
        //            this.setState({
        //                RemitterCode: response.data.RemitterCode,
        //                url: config.url.Web_URL + '/' + response.data.RemitterCode
        //            });
        //        } else {
        //            window.location.href = config.url.Web_URL + `/Error/404`;
        //            return;
        //        }
        //    })
        //    .catch(error => {
        //        console.log(error);
        //    });

        axios.get(global.Part2.GetPart2API,
            { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } },
            { responseType: 'json' })
            .then(response => {
                if (response.status) {
                    console.log(response.data.data);
                    this.setState({
                        part2: response.data.data
                    });
                }
                else {
                    this.setState({
                        part2: []
                    });
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    showNoti(title, message, type) {

        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });

    };

    static handleDownload(rowContent) {
        axios.get(global.Part2.DownloadBulkDetailsPart2API + rowContent,
            {
                headers: { "Authorization": `Bearer ${localStorage.getItem('token')}`, 'Accept': 'application/zip' },
                responseType: 'blob'
            })
            .then(response => {
                const content = response.headers['content-type'];
                const fileName = "Part2Shareholder Details_" + moment().format("DD/MM/YYYY") + ".zip"
                download(response.data, fileName, content)
            })
            .catch(error => {
                console.log(error);
            });
    }


    modalClose() {
        this.setState({
            file: "",
            modal: false
        });
    }

    handleUploadClick = (event) => {
        this.setState({ loading: true });

        event.preventDefault();
        //var self = this;
        if (this.state.filesToBeSent != undefined) {

            var filesArray = this.state.filesToBeSent;
            let form = new FormData();
            form.append("File", filesArray);
            form.append("fileName", filesArray.name);
            form.append("assignmentCode", this.state.assignmentCode);

            axios.post(global.Part2.UploadPart2Shareholder, form,
                {
                    headers: { "Authorization": `Bearer ${localStorage.getItem('token')}`, 'Accept': 'application/xlsx' },
                    responseType: 'blob'
                })
                .then(response => {
                    if (response) {

                        this.showNoti("Notification", global.Message.SuccessMessage, "success");

                        const content = response.headers['content-type'];
                        const fileName = "Log.xlsx";

                        download(response.data, fileName, content);

                        this.setState({ loading: false });
                        this.setState({ modal: false, file: '', filesToBeSent: '', fileName: '' });

                    } else {
                        this.showNoti("Notification", response.Message, "danger");
                        this.setState({ loading: false });
                    }
                })
                .catch(error => {
                    this.setState({ loading: false });
                    console.log(error);
                });

        }
        else {
            this.setState({ loading: false });;
            alert("Please select files first");
        }
    }
    handelFileChange = event => {
        let file = event.target.files[0];
        var type = file.name.substring(file.name.lastIndexOf('.') + 1);
        if (type == "xlsx" || type == "xls") {
            this.setState({ filesToBeSent: event.target.files[0] });
        }
        else {
            this.showNoti("Notification", global.Message.FormatRequiredMessage, "danger");
        }
    };

    render() {
        if (this.state.loading) return <Spinner />;
        let contentFooter = Layout.RenderFooter();
        const options = {
            custom: true,
            paginationSize: 4,
            pageStartIndex: 1,
            firstPageText: 'First',
            prePageText: 'Back',
            nextPageText: 'Next',
            lastPageText: 'Last',
            nextPageTitle: 'First page',
            prePageTitle: 'Pre page',
            firstPageTitle: 'Next page',
            lastPageTitle: 'Last page',
            showTotal: true,
            totalSize: this.state.part2.length
        };

        const contentTable = ({ paginationProps, paginationTableProps }) => (
            <div>
                <ToolkitProvider
                    keyField="AssignmentCode"
                    columns={this.state.columns}
                    data={this.state.part2}
                    search
                >
                    {
                        toolkitprops => (
                            <div>
                                <SearchBar {...toolkitprops.searchProps} />
                                <BootstrapTable
                                    hover
                                    {...toolkitprops.baseProps}
                                    {...paginationTableProps}
                                    wrapperClasses="table-responsive" />
                            </div>
                        )
                    }
                </ToolkitProvider>
                <PaginationListStandalone {...paginationProps} />
            </div>
        );
        let content = Layout.RenderNavMenu()
  
        return (
            <div>
                <ReactNotification />
                {content}
                <div className="Nexdigm">
                    <ol className="breadcrumb btn-Nexdigm">

                        <li><a href={this.state.URL + "/Nexdigm/Dashboard"} className="text-white"><FontAwesomeIcon icon="home" /> Home</a></li>
                        <li><a className="text-white">Part 2</a></li>
                    </ol>
                </div>
                <div className="content-page">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="header-title">Part 2 Details</h4>

                            <PaginationProvider
                                pagination={
                                    paginationFactory(options)
                                }
                            >
                                {contentTable}
                            </PaginationProvider>

                        </div>
                    </div>
                </div>
                {contentFooter} 
                <div>
                    <Popup show={this.state.modal} handleClose={e => this.modalClose}>
                        <div className="form-group">
                            <form method="post" encType="multipart/form-data">
                                <div className="form-group">
                                    <div className="col-md-6">

                                        <br />
                                        <input type="file" name="files" multiple onChange={this.handelFileChange} />
                                    </div>
                                </div> 
                                <div className="form-group">
                                    <div className="col-md-12">
                                        <button className="btn btn-success" type="button" onClick={this.handleUploadClick}>Upload</button>
                                        <button className="btn btn-default m-l-10" type="button" onClick={this.modalClose}>Cancel</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </Popup>

                </div>
            </div>
            
        );
    }
}
